import Preview from './Modules/preview';
import Input from './Modules/input';

const Modules = {
  Preview,
  Input
};

export default Modules;
